import {Spin, Typography} from "antd";
import {convertStringToTemperatureUnit, convertTemperature, ETemperatureUnit} from "contracts/ETemperatureUnit";
import React, {useContext, useMemo} from 'react';
import {useTemperatureConverterForOrganisation} from "utils/useTemperatureConverterForOrganisation";
import {ExperienceGroup} from "contracts/holotrak/experienceGroup";
import {OrganisationContext} from "utils/organisationContext";

const {Text} = Typography;

interface ITemperatureRendererProps {
    value: string;
    inputUnit: ETemperatureUnit;
    outputUnit?: ETemperatureUnit;
    fallback?: string;
    className?: string;
}

interface IOrganizationalTemperatureRendererProps extends ITemperatureRendererProps {
    organisation: ExperienceGroup;
}

/**
 * This component has been created so we can reuse the custom hook for computing the temperature reported without any wrapper.
 *
 *
 * @param {ITemperatureRendererProps} props - The properties for the TemperatureRendererV2 component.
 */
export const TemperatureRendererV2: React.FC<ITemperatureRendererProps> = (props) => {
    const {convert: convertToOrganizational, temperatureUnit} = useTemperatureConverterForOrganisation();

    return (
        <>
            {`${convertToOrganizational(props.value, props.inputUnit).toFixed(1)}°${temperatureUnit}`}
        </>
    )
}

/**
 * Deprecated Since v3.13.87
 * To allow using custom hook and let component user decide whether we need a wrapper or not.
 *
 * @param props
 * @constructor
 */
export const TemperatureRenderer: React.FC<ITemperatureRendererProps> = (props) => {
    const organisation = useContext(OrganisationContext);


    return (
        <span style={{display: 'inline-block'}}>
          <Spin spinning={!organisation}>
            {
                organisation && (
                    <OrganizationalTemperatureRenderer organisation={organisation} {...props}/>
                )
            }
          </Spin>
        </span>
    );
};

export const OrganizationalTemperatureRenderer: React.FC<IOrganizationalTemperatureRendererProps> = ({
                                                                                                         organisation,
                                                                                                         value,
                                                                                                         inputUnit,
                                                                                                         outputUnit,
                                                                                                         className,
                                                                                                         fallback = '-'
                                                                                                     }) => {

    const temperatureUnit = convertStringToTemperatureUnit(outputUnit || organisation.temperatureUnit);

    const convertedValue = useMemo(() => {
        return convertTemperature(value, inputUnit, temperatureUnit);
    }, [value, inputUnit, temperatureUnit]);

    return (
        <Text className={className}>
            {
                (value && !isNaN(convertedValue))
                    ? `${convertedValue}°${temperatureUnit}`
                    : fallback
            }
        </Text>
    );
}
